const host = window.location.host
export const isDev = process.env.NODE_ENV === 'development'
export const isTest = /.+\.test\.simboss\.com$/.test(host)
export const isPrepare = host === 'simboss-banner.prepare.simboss.com'

const preparePentagon = '//simboss-pentagon.prepare.simboss.com'
const onlinePentagon = '//www.simboss.com'

// 由于存在自定义域名，所以默认地址必须为线上
export const PENTAGON_URL = (
  isDev ? preparePentagon
    : isTest ? preparePentagon
      : isPrepare ? preparePentagon
        : onlinePentagon
)

export const goPentagon = () => {
  window.location.href = PENTAGON_URL + '/www/home'
}
